export default __webpack_public_path__ + "static/media/status-active.fea7d46d.svg";